import { render, staticRenderFns } from "./Manage.vue?vue&type=template&id=23c6cd54&scoped=true"
import script from "./Manage.vue?vue&type=script&lang=js"
export * from "./Manage.vue?vue&type=script&lang=js"
import style0 from "./Manage.vue?vue&type=style&index=0&id=23c6cd54&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c6cd54",
  null
  
)

export default component.exports